import { Card } from "../ui/Card.jsx";
import { IconTile } from "../ui/IconTile.jsx";
import { SectionHeading } from "../ui/SectionHeading.jsx";
import { Icon } from "../ui/Icon.jsx";
import { INDUSTRIES } from "./HeroMock.jsx";

export function WhatWeDo({ activeIndustry }) {
  const active = INDUSTRIES[activeIndustry];
  const items = [
    {
      icon: <Icon.Search />,
      title: "Find",
      body: "Demand you already qualify for and aren't capturing. We look past your own systems into the record of what you have actually done and who is actually in your market.",
    },
    {
      icon: <Icon.Brain />,
      title: "Understand",
      body: "Your business described in your own vocabulary, not a generic template — and every claim in it scored, sourced and open to challenge. This is the part nobody else builds.",
    },
    {
      icon: <Icon.Bolt />,
      title: "Engage",
      body: "We don't hand you a recommendation. We build and run the software that acts on it, inside the stack you already have, and report back what it earned.",
    },
  ];

  return (
    <section className="section" id="what">
      <div className="container">
        <SectionHeading eyebrow="What we do" title="Find. Understand. Engage." />
        <div className="grid-3">
          {items.map((it, i) => (
            <Card key={i} className="info-card" data-reveal>
              <IconTile icon={it.icon} />
              <h3>{it.title}</h3>
              <p>{it.body}</p>
              <div className="what-example">{active.whatExamples[i]}</div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
